<template>
  <div id="supCutterC">
    <el-row>
      <el-col :span="9" :offset="0.5">
        <el-row>
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <span>请选择订单号:</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="orderId" placeholder="请选择">
                <el-option v-for="item in orders" :key="item.id" :label="item.id" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                :loading="startloading"
                type="primary"
                @click="startChooes"
                v-if="orders.length!=0&&orderId!=''"
                :disabled="isChoose"
              >开始选择刀具</el-button>
              <span v-if="orders.length==0">无可选订单</span>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <OrderLabel
            :order="order"
            :disabled="true"
            :label="label"
            :files="files"
            v-if="orderId"
            :users="users"
          ></OrderLabel>
        </el-row>
      </el-col>

      <el-col :span="12" v-if="isChoose==true" style="margin: 10px 0px 0px 10px;height: 100%">
        <h3 style="text-align: center; margin: 10px 10px 40px 0px">材料种类: {{label.material}}</h3>
        <div style="text-align: center">
          <!-- 第一步 -->
          <div v-if="activate==0">
            <el-row style="margin-left: 10px">
              <el-table
                :data="cutters"
                style="width: 90%"
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                border
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="刀模名字"></el-table-column>
                <el-table-column prop="row" label="行数"></el-table-column>
                <el-table-column prop="line" label="列数"></el-table-column>
                <el-table-column prop="times" label="使用次数"></el-table-column>
                <el-table-column prop="useTime" label="上次时间"></el-table-column>
              </el-table>
            </el-row>
            <el-row style="margin-top: 30px">
              <el-button @click="toggleSelection()">清 空</el-button>
              <el-button type="primary" @click="next">下一步</el-button>
            </el-row>
          </div>
          <!-- 第二步 -->
          <div v-if="activate==1">
            <el-row>
              <el-col :offset="5" :span="18">
                <table border="1" cellspacing="0" style="width: 80%">
                  <tr>
                    <th>刀模名字</th>
                    <th>行数</th>
                    <th>列数</th>
                    <th>使用次数</th>
                    <th>上次时间</th>
                  </tr>
                  <template v-for="item in chooseC">
                    <tr>
                      <td>{{item.name}}</td>
                      <td>{{item.row}}</td>
                      <td>{{item.line}}</td>
                      <td>{{item.times}}</td>
                      <td>{{item.useTime}}</td>
                    </tr>
                  </template>
                </table>
              </el-col>
            </el-row>
            <el-row style="margin-top: 30px">
              <el-button @click="back">上一步</el-button>
              <el-button type="primary" @click="commit">确 定</el-button>
            </el-row>
          </div>
        </div>
      </el-col>

      <!-- 状态栏 -->
      <el-col :span="2" v-if="isChoose==true" style="margin-top: 80px">
        <div style="height: 300px;">
          <el-steps direction="vertical" :active="activate" finish-status="success">
            <el-step title="选刀具"></el-step>
            <el-step title="提交"></el-step>
          </el-steps>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import OrderLabel from "@/components/production/OrderLabel";
import Vue from "vue";
export default {
  components: {
    OrderLabel
  },
  data: function() {
    return {
      orders: [],
      //终端发出
      postApi: {
        crud: "",
        info: {}
      },
      //终端接收
      message: {
        result: {
          infos: []
        }
      },
      orderId: "",

      //订单信息
      order: {},

      //标签信息
      label: {},

      //相关人员信息
      users: {},

      //附件信息
      files: {},

      startloading: false,

      activate: 0,

      //选取信息
      cutters: [],
      chooseC: [],
      isChoose: false,

      orderStatus: 2
    };
  },
  created: function() {
    this.init();
  },
  watch: {
    orderId: async function(val) {
      if (val != "") {
        this.postApi.crud = "ri";
        this.postApi.info = {
          key: val
        };
        this.message = await this.$doPost(
          "/api/production/order",
          this.postApi
        );
        if (this.message.msgCode == 0) {
          this.order = this.message.result.infos.order;
          this.label = this.message.result.infos.label;
          this.files = this.message.result.infos.files;
          this.users = this.message.result.infos.users;
        } else {
          this.$message.error(this.message.msg);
        }
      }
      //关闭选择
      this.isChoose = false;
      this.chooseC = [];
      this.cutters = [];
      this.activate = 0;
    }
  },
  methods: {
    getCutters: function() {},
    init: async function() {
      this.orderId = "";

      this.postApi.crud = "r";
      this.postApi.info = {
        key: {
          id: "",
          superSearch: true,
          orderStatus: this.orderStatus,
          searchTime: null
        }
      };
      this.message = await this.$doPost("/api/production/order", this.postApi);
      if (this.message.msgCode == 0) {
        this.orders = this.message.result.infos;
      } else {
        this.$message.error(this.message.msg);
        this.orders = [];
      }
    },
    startChooes: async function() {
      this.startloading = true;
      this.postApi.crud = "r";
      this.postApi.info = {
        key: this.label,
        orderId: this.orderId
      };
      this.message = await this.$doPost(
        "/api/production/choosecutter",
        this.postApi
      );
      if (this.message.msgCode == 0) {
        this.cutters = this.message.result.infos;
        this.isChoose = true;
      } else {
        this.$message.error(this.message.msg);
      }
      this.startloading = false;
    },
    //动态选取
    handleSelectionChange(val) {
      this.chooseC = val;
    },
    //清空
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    next: function() {
      var error = "";
      if (this.activate == 0) {
        if (this.chooseC.length == 0) {
          error += "请选取刀具";
        }
      } else if (this.activate == 1) {
        for (var itme in this.chooseDetail) {
          if (error != "") break;
          for (var i in this.chooseDetail[itme]) {
            if (
              this.chooseDetail[itme][i].prepareM <= 0 ||
              this.chooseDetail[itme][i].prepareM == "" ||
              this.chooseDetail[itme][i].rollNum <= 0 ||
              this.chooseDetail[itme][i].rollNum == ""
            ) {
              error += "只能输入正数";
              break;
            }
          }
        }
      }
      if (error === "") {
        this.activate += 1;
      } else {
        this.$message.warning(error);
      }
    },
    back: function() {
      this.activate -= 1;
    },
    commit: async function() {
      this.postApi.crud = "c";
      this.postApi.info = {
        orderId: this.orderId,
        choose: this.chooseC,
      };
      this.message = await this.$doPost(
        "/api/production/choosecutter",
        this.postApi
      );
      if (this.message.msgCode == 0) {
        this.$message.success("刀具选取成功");
        this.init();
      } else {
        this.$message.error(this.message.msg);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>
<style>
/* td{
  margin-bottom: 
} */
</style>



// WEBPACK FOOTER //
// src/components/production/SupCutterC.vue